export default __webpack_public_path__ + "static/dog-d58fc7f0a84db801241d46c12fac5286.svg";